import { Modal } from "react-bootstrap";
import { SubmitButton, CancelButton } from "../../shared";

export function ConfirmActionModal({
  show,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "danger",
  isSubmitting = false,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal
      show={show}
      onHide={isSubmitting ? undefined : onCancel}
      centered
      className="commission-modal-scope"
    >
      <Modal.Header closeButton={!isSubmitting}>
        <Modal.Title className="fs-6 fw-bold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-secondary small mb-0">{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton
          text={cancelLabel}
          onClick={onCancel}
          disabled={isSubmitting}
        />
        <SubmitButton
          text={confirmLabel}
          variant={confirmVariant}
          isSubmitting={isSubmitting}
          onClick={onConfirm}
        />
      </Modal.Footer>
    </Modal>
  );
}
